import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ParticipantDetailsPage, { getDefaultUI } from "components/pages/ParticipantDetailsPage";
import Classes, { Participant } from "model";

export default function CaptureParticipantDetailsStatusOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init({ participant: Participant.init({ participantType: "standard", accountType: "Checking", status: "active" }) })
    .update([ "participant", "participantName" ], "Thomas Jefferson")
    .update([ "participant", "participantEmail" ], "tjefferson@presidentsinc.com")
    .update([ "participant", "nickname" ], "TJefferson")
    .update([ "participant", "institutionName" ], "PRESIDENTS BANK AND TRUST")
    .update([ "participant", "routing" ], "999888766")
    .update([ "participant", "uniqueID" ], "555-66-7777")
    .update([ "participant", "number" ], "1234567")
    .update([ "participant", "confirmedAccountNumber" ], "1234567")
    .update([ "participant", "accountType" ], "Checking")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "statusSelectIsActive" ], true)
    .submit();

    return <ParticipantDetailsPage data={ data } ui={ ui } />
}